import { Product, Weight } from "generated/graphql";
import React from "react";

export const ProductContext = React.createContext(null);
export const formError = {
  submitted: false,
  name: {
    error: false,
    required: true,
  },
  reference: {
    error: false,
    required: true,
  },
  description: {
    error: false,
    required: true,
  },
  category: {
    error: false,
    required: true,
  },
  weigth: {
    error: false,
    require: false,
  },
  value: {
    error: false,
    required: true,
  },
  volume: {
    error: false,
    required: false,
  },
};

export const ProductEmptyForm = {
  name: "",
  reference: "",
  description: "",
  category: null as any,
  weight: Weight.S,
  volume: null as any,
  value: 25,
};
export const ProductProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [product, setProduct] = React.useState<Product>(ProductEmptyForm);
  const [error, setError] = React.useState(formError);
  const [image, setImage] = React.useState<File>(null);

  return (
    <ProductContext.Provider
      value={{
        product,
        setProduct,
        image,
        setImage,
        error,
        setError,
      }}
    >
      {children}
    </ProductContext.Provider>
  );
};
